import { render, staticRenderFns } from "./c-good-item.vue?vue&type=template&id=7f6220d9&scoped=true&"
import script from "./c-good-item.vue?vue&type=script&lang=js&"
export * from "./c-good-item.vue?vue&type=script&lang=js&"
import style0 from "./c-good-item.vue?vue&type=style&index=0&id=7f6220d9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f6220d9",
  null
  
)

export default component.exports